import React from 'react';
import './Tour.css';

import { calculateAverageRating } from '../../utils';

import { FaStar, FaCalendar, FaMap } from 'react-icons/fa';

import { Link } from 'react-router-dom';



const Tour = ({ tour }) => {

  // Calculate the average rating of the tour, based on user reviews
  const averageRating = calculateAverageRating(tour);

  return (
    <div className="tour-item">

      <img src={tour.image} alt={tour.title} /> {/* Tour image */}

      <div className="content">

        <div className="price">${tour.details.price}</div> {/* Tour Price */}

        <div className='intro'>

          {/* Tour rating */}
          <div className='rating'>
            <div className='icon'>
              {/* Display star icons for rating */}
              <FaStar /> <FaStar /> <FaStar /> <FaStar /> <FaStar />
            </div>
            {/* Display average rating and number of comments */}
            {tour.comments.length > 0 ? (
              <h5>{averageRating} ({tour.comments.length})</h5>
            ) : (
              <h5>Not rated</h5>
            )}
          </div>

          {/* Tour title with link to Tour details page */}
          <Link to={{
              pathname: '/Tours/' + tour.title,
          }}
          state={tour}>{tour.title}
          </Link>

          <p>{tour.content}</p> {/* Tour Description */}

        </div>

        {/* Tour Details */}
        <div className="details">
          <h3><FaCalendar className="icon" /><span>{tour.details.duration}</span></h3> {/* Tour Duration */}
          <h3><FaMap className="icon" /><span>{tour.details.location}</span></h3> {/* Tour Location */}
        </div>

      </div>
    </div>
  );
};

export default Tour;